// extracted by mini-css-extract-plugin
export default {"modal":"modal__Vb4Pd"};